import { useState } from 'preact/hooks';
import * as stylex from '@stylexjs/stylex';
import { Select, Field, Button, Spinner } from '@xantory/ui';
import { useConfigStore, useAuthStore } from '@xantory/store';
import { useSites } from '@xantory/api';
import { useT } from '@xantory/i18n';
import { navigate } from '../manifest';
import { ROUTES } from '../routes';
import { styles } from './site-select.styles';

/**
 * Cloud-mode gate: pick which site (`/sites/{id}`) to operate on. Shown after login while no site is
 * selected. The list comes live from gateway-cloud (`GET /users/v1/sites`); the choice is persisted.
 */
export function SiteSelectPage() {
  const t = useT('siteSelect');
  const setSite = useConfigStore(s => s.setSite);
  const isAdmin = useAuthStore(s => s.user?.userType) === 'admin';
  const [picked, setPicked] = useState('');
  const {
    data,
    isLoading,
    isError
  } = useSites();
  const sites = data?.sites ?? [];
  const confirm = () => {
    const site = sites.find(s => s.id === picked);
    if (site) setSite(site.id, site.name);
  };
  return <div {...stylex.props(styles.page)}>
      <div {...stylex.props(styles.card)}>
        <div {...stylex.props(styles.header)}>
          <p {...stylex.props(styles.title)}>{t('title')}</p>
          <p {...stylex.props(styles.subtitle)}>{t('subtitle')}</p>
        </div>

        <div {...stylex.props(styles.body)}>
          {isLoading ? <Spinner block /> : isError ? <p {...stylex.props(styles.error)}>{t('loadError')}</p> : sites.length === 0 ?
        // With zero sites, an admin isn't stuck here — they can jump straight to Administration
        // → Sites to create the first one (R-150). Non-admins genuinely have nothing to pick.
        <>
              <p {...stylex.props(styles.message)}>{isAdmin ? t('noSitesAdmin') : t('noSites')}</p>
              {isAdmin && <Button block onClick={() => navigate(ROUTES.sites)}>
                  {t('createSite')}
                </Button>}
            </> : <>
              <Field label={t('site')}>
                <Select options={[{
              value: '',
              label: t('pickOne')
            }, ...sites.map(s => ({
              value: s.id,
              label: s.name ?? s.id
            }))]} value={picked} onChange={e => setPicked((e.currentTarget as HTMLSelectElement).value)} />
              </Field>
              <Button block disabled={!picked} onClick={confirm}>
                {t('continue')}
              </Button>
            </>}
        </div>
      </div>
    </div>;
}